import React, { useState, useEffect } from "react";
import "./FAQ.css";
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import faqbanner from "./assets/faq.jpg";

const FAQ = () => {
    useEffect(() => {
        // Trigger animations on mount
        const banner = document.querySelector(".banner");
        const text = document.querySelector(".banner-text");
        banner.classList.add("slide-in");
        text.classList.add("slide-in-text");
      }, []);
      
    const [isVisible, setIsVisible] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);

    useEffect(() => {
        setIsVisible(true);

        const handleScroll = () => {
            const elements = document.querySelectorAll('.fade-in');
            elements.forEach(el => {
                const elementTop = el.getBoundingClientRect().top;
                const elementVisible = 150;
                if (elementTop < window.innerHeight - elementVisible) {
                    el.classList.add('active');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqData = [
        {
            question: "What does SKC Japan do?",
            answer: "SKC Japan specializes in the export of high-quality Japanese vehicles to customers worldwide. We make the process simple, transparent, and affordable, ensuring smooth transactions from purchase to delivery."
        },
        {
            question: "How can I purchase a vehicle from SKC Japan?",
            answer: "You can browse our available stock on our website. Once you select a vehicle, contact our sales team to confirm details, pricing, and shipping arrangements. We guide you through each step of the process."
        },
        {
            question: "Do I need to make full payment upfront?",
            answer: "No. SKC Japan offers flexible payment options. Generally, a 30% advance payment is required to secure the vehicle, with the remaining balance due before shipment."
        },
        {
            question: "What shipping methods are available?",
            answer: "We primarily ship vehicles via RORO (Roll-on Roll-off) and container shipping. The method depends on your destination, budget, and preferences. Our team will advise the best option for your order."
        },
        {
            question: "How long does shipping take?",
            answer: "Shipping time varies depending on the destination country and port schedule. On average, it takes 3–6 weeks from the time of shipment to delivery."
        },
        {
            question: "Can SKC Japan handle customs clearance?",
            answer: "We handle all export documentation from Japan. For customs clearance in your country, you may need a local customs broker or clearing agent. We can guide you on requirements."
        },
        {
            question: "Are the vehicles inspected before shipping?",
            answer: "Yes. Every vehicle is carefully inspected to ensure it meets quality and safety standards before being shipped. Inspection certificates can be provided upon request."
        },
        {
            question: "Do you export to my country?",
            answer: "We ship to most major international ports. Please contact our team with your location, and we will confirm shipping availability and cost for your destination."
        },
        {
            question: "What currencies do you accept?",
            answer: "We accept payments in Japanese Yen (JPY) as well as major international currencies (USD, EUR, etc.). Bank transfer is the most common payment method."
        },
        {
            question: "Why choose SKC Japan?",
            answer: (
                <ul className="faq-details">
                    <li>Trusted exporter with years of experience.</li>
                    <li>Affordable pricing with transparent costs.</li>
                    <li>Professional support throughout the buying process.</li>
                    <li>Commitment to customer satisfaction and quality vehicles.</li>
                </ul>
            )
        },
        {
            question: "Do you sell only used cars or new cars as well?",
            answer: "We mainly export pre-owned vehicles from Japan, but depending on availability, we may also provide brand-new or nearly-new cars."
        },
        {
            question: "Can I request a specific car if it’s not in your stock?",
            answer: "Yes. If the car you want is not currently listed, we can help you source vehicles directly from Japanese auctions or local dealers."
        },
        {
            question: "Do the vehicles come with auction sheets or inspection reports?",
            answer: "Yes. For vehicles purchased through auctions, we provide the auction sheet and grading report. This helps you verify the condition and authenticity of the vehicle."
        },
        {
            question: "What happens if my vehicle is damaged during shipping?",
            answer: "Not all vehicles are automatically insured. If your vehicle is covered by marine insurance, you can file a claim in the unlikely event of damage during shipping. We recommend requesting insurance at the time of purchase for added protection."
        },
        {
            question: "Can I track my shipment?",
            answer: "Yes. Once your vehicle has been shipped, we provide you with the Bill of Lading (B/L) and tracking details so you can monitor its status."
        },
        {
            question: "What other costs should I expect apart from the car price?",
            answer: (
                <ul className="faq-details">
                    <li>Freight charges (shipping cost)</li>
                    <li>Marine insurance (optional but recommended)</li>
                    <li>Customs duties, taxes, and clearance fees in your country</li>
                </ul>
            )
        },
        {
            question: "Do you provide spare parts or accessories?",
            answer: "Yes. Along with vehicles, we can also assist with exporting genuine Japanese spare parts and accessories if requested."
        },
        {
            question: "How can I be sure SKC Japan is a trusted company?",
            answer: "We are a legally registered company in Yokohama, Japan, with years of experience in vehicle export. Many of our customers are repeat buyers, and we operate with transparency, verified documentation, and professional service."
        }
    ];

    return (
        <div className="container-fluid p-0">
            <div className="row no-gutters">
                <div className="col-lg-2 col-md-3 col-12 leftcol">
                    <LeftSection />
                </div>
                <div className="col-lg-8 col-md-9 col-12 middlecol">

                    <div className="banner-wrapper">
                        <div className="banner" style={{ backgroundImage: `url(${faqbanner})` }}>
                            <div className="banner-text">FAQ</div>
                        </div>
                    </div>

                    <div className={`faq-section ${isVisible ? 'visible' : ''}`}>
                        <div className="faq-content">
                            <div className="mainbox fade-in">
                                <div className="quote-icon">❓</div>
                                <p className="mainsent">
                                    Got questions? We've got answers! Explore our FAQs to learn more about purchasing vehicles from SKC Japan.
                                </p>
                            </div>

                            <div className="faq-container">
                                <div className="section-header center fade-in">
                                    <h2>Frequently Asked Questions</h2>
                                    <p>Everything you need to know about buying and shipping vehicles with SKC Japan</p>
                                </div>

                                {faqData.map((faq, index) => (
                                    <div key={index} className="faq-item fade-in">
                                        <div className="faq-header" onClick={() => toggleAccordion(index)}>
                                            <div className="faq-number">
                                                <div className="number-circle">{index + 1}</div>
                                            </div>
                                            <div className="faq-question">
                                                <h3>{faq.question}</h3>
                                                <span className={`accordion-icon ${openIndex === index ? 'open' : ''}`}>
                                                    {openIndex === index ? '−' : '+'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                                            <div className="faq-answer-content">
                                                {faq.answer}
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className="summary-section fade-in">
                                    <div className="summary-card">
                                        <div className="summary-header">
                                            <h2>✅ Still Have Questions?</h2>
                                        </div>
                                        <div className="summary-features">
                                            <div className="feature">
                                                <div className="feature-icon">📧</div>
                                                <p>Contact our support team for personalized assistance</p>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-icon">✔️</div>
                                                <p>Fast and reliable responses</p>
                                            </div>
                                            <div className="feature">
                                                <div className="feature-icon">🌐</div>
                                                <p>Worldwide support for your needs</p>
                                            </div>
                                        </div>
                                        <div className="cta-button">
                                            <button className="cta-primary">Get in Touch Now</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-2 col-12 rightcol">
                    <RightSection />
                </div>
            </div>
        </div>
    );
};

export default FAQ;